import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { loadDt } from "./loadDt";

export var fillActivateStudents = function(courseId, holder="card-activate-students"){

    const success = function (data){
        const obj = $("#" + holder);
          // table.DataTable().destroy();
          obj.html(data.html);
          const table = obj.find("table");
  
          table.DataTable(loadDt(table));
    }

    const url = '/course/' + courseId.toString() + "/students";

    ajaxRequest(url, success, {}, false);

  }
  
  export var fillAdminCourseDetails = function(courseId, holder="#card-course-details"){

    const obj = $(holder);

    const success = function(data){
        obj.html(data.html)
    }

    const url = '/course/' + courseId.toString() + '/details';

    ajaxRequest(url, success, {}, obj);

  }

  export var changeCourseListItem = function(item){
    const parent = item.parent();
    parent.find(".m-f-t-item").removeClass("chosen");
    item.addClass("chosen");
    return item.attr("data-fach");
  }

  export var changeUserActivationStatus = function(element){
    const reactivate = 'reactivate-user text-success btn-light-success';
    const reactivateBadge = 'bg-light-danger text-danger';
  
    const deactivate = 'deactivate-user text-danger btn-light-danger';
    const deactivateBadge = 'bg-light-success text-success';
  
    const badge = element.parent().parent().find(".status-badge");
  
    if (element.hasClass("deactivate-user")){
      element.removeClass(deactivate).addClass(reactivate);
      element.html('<i class="mdi mdi-refresh"></i>');
      element.attr('data-bs-original-title', 'Schüler/-in reaktivieren')
      badge.removeClass(deactivateBadge).addClass(reactivateBadge);
      badge.html("Inaktiv");
  
    } else if (element.hasClass("reactivate-user")){
      element.removeClass(reactivate).addClass(deactivate);
      element.html('<i class="mdi mdi-close-circle"></i>');
      element.attr('data-bs-original-title', 'Schüler/-in deaktivieren')
      badge.removeClass(reactivateBadge).addClass(deactivateBadge);
      badge.html("Aktiv");
    }
  }


  export var fillAvailableTutors = function(courseId){

    const holder = $("#available-tutors");

    const url = '/course/' + courseId.toString() + '/tutors/available'

    const success = function(data){
        holder.html(data.html);
    }

    ajaxRequest(url, success, {}, $("#available-tutors"));

  }